import { get_currentSessionNotNull30vuua77prq38 as get_currentSessionNotNull } from '../../sdk/currentSession.mjs';
import {
  await1uwe8zvsjq69o as await_0,
  await1xlt6i5aa076q as await_1,
} from '../../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { EmptySerializersModule991ju6pz9b79 as EmptySerializersModule } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/modules/SerializersModuleBuilders.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { StringDeferringConfig2dp4ygunddfnv as StringDeferringConfig } from '../../../../../../kotlinx-serialization-csv-durable/com/lightningkite/kotlinx/serialization/csv/StringDeferringConfig.mjs';
import { CsvFormat2d7d3ollhiney as CsvFormat } from '../../../../../../kotlinx-serialization-csv-durable/com/lightningkite/kotlinx/serialization/csv/CsvFormat.mjs';
import {
  ListSerializer1hxuk9dx5n9du as ListSerializer,
  get_nullable197rfua9r7fsz as get_nullable,
} from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/builtins/BuiltinSerializers.mjs';
import { toBlob3efqyqa0phgb9 as toBlob } from '../../../../../../kiteui-library/com/lightningkite/kiteui/fetch.js.mjs';
import { download3e9i5zj8k9dp8 as download } from '../../../../../../kiteui-library/com/lightningkite/kiteui/ExternalServices.mjs';
import { orPromise1iucc2to2udt2 as orPromise } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { Queryam9ckqg1rxkb as Query } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/Query.mjs';
import { Companion_instance177q6f44m9gy2 as Companion_instance } from '../components/remittanceBreakdownGrid.mjs';
import {
  Cents1lsbs5l1tlgw as Cents,
  _Cents___init__impl__6gjhxu21pac6t02ivb3 as _Cents___init__impl__6gjhxu,
  Cents__plus_impl_qsv4s83hvgnvnlu2892 as Cents__plus_impl_qsv4s8,
  Cents__toDouble_impl_mg3etm3dxlfojyivr3o as Cents__toDouble_impl_mg3etm,
} from '../../../../../../service-abstractions-currency/com/lightningkite/services/data/Cents.mjs';
import {
  Companion_instance1lm8x0jadqh2g as Companion_instance_0,
  Platform_Web_getInstance2840w5bkfolz8 as Platform_Web_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/Platform.mjs';
import { get_current2r182tjucmm5v as get_current } from '../../../../../../kiteui-library/com/lightningkite/kiteui/Platform.js.mjs';
import {
  Signal1973xs1vkmdcb as Signal,
  _Constant___init__impl__v45mub2qfk15kh5l39c as _Constant___init__impl__v45mub,
  Constant3smypj7m9af27 as Constant,
} from '../../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import {
  ReportFiltersigb451dg4asm as ReportFilters,
  reportFilterMenu2u8jz7auzgjn6 as reportFilterMenu,
  reportFilterBar2ow9csmm0mu97 as reportFilterBar,
} from './ReportFilters.mjs';
import { get_scrolling3fwkltztkpfe8 as get_scrolling } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import { RowOrCol3a33s3yce2tuv as RowOrCol } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/LinearLayouts.commonHtml.mjs';
import {
  ensureOutermostElement1f4fzdv7yw0ql as ensureOutermostElement,
  Companion_getInstanceztgx4sy4wjnt as Companion_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/NativeElement.mjs';
import { CompactSemantic_getInstance3lxnpjuev524m as CompactSemantic_getInstance } from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { themed2vu67ornd4jps as themed } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import { get_atBottomStart1iulwjfo1udg3 as get_atBottomStart } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import {
  weight31wqab1913ly4 as weight,
  shownWhen3t7othivfr11 as shownWhen,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import { h12aidul0n4qlwh as h1 } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/shortcuts.mjs';
import { Action2nhdpxpznfsbd as Action } from '../../../../../../kiteui-library/com/lightningkite/kiteui/reactive/Action.mjs';
import { exportButton1ekt3fxzrhh34 as exportButton } from '../components/view-utilities.mjs';
import { rememberSuspending14xvgr29y3z54 as rememberSuspending } from '../../../../../../reactive/com/lightningkite/reactive/core/RememberSuspending.mjs';
import { SwapView1526g6cz7z56r as SwapView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/SwapView.commonHtml.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { Companion_getInstance29ka8gqgdrya1 as Companion_getInstance_0 } from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/ScreenTransitions.mjs';
import { Exceptiondt2hlxn7j7vw as Exception } from '../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  toString30pk9tzaqopn as toString,
  arrayOf1akklvh2at202 as arrayOf,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { report1vfr9zf0i9d9p as report } from '../../../../../../kiteui-library/com/lightningkite/kiteui/debugger.mjs';
import { reactive2xic0rufq5s8n as reactive } from '../../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import { Spaceoq5xo9lsieqc as Space } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Space.commonHtml.mjs';
import { Page1o437w9xuocrm as Page } from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Page.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import {
  ChildPlacement1fdgqwhgo48yv as ChildPlacement,
  IDknm0szoty74n as ID,
  Family2k7vz7ddyergb as Family,
  IDjecfjjw6mot9 as ID_0,
  CareProvider2qcawrqluyllr as CareProvider,
  ID1m87d1hextx54 as ID_1,
  CareLocation1v3u5wduz023s as CareLocation,
  ID1z61wlmtvxrjn as ID_2,
} from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/domain.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { serializerOrContextual2mm942ha7plg6 as serializerOrContextual } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/SerializationHelpers.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { DataClassPathSelf18kqeagzkbefr as DataClassPathSelf } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/DataClassPath.mjs';
import {
  get__id1elsu38391a1o as get__id,
  get__id336i6k806byxy as get__id_0,
  get__id1301miildb0kq as get__id_1,
  get__id2p9nbcwbj0zlw as get__id_2,
  get__id2ft65q2wfav1v as get__id_3,
} from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/ModelFields-372156621.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import {
  toSet2orjxp16sotqu as toSet,
  joinToString1cxrrlmo0chqs as joinToString,
  sortedWith2csnbbb21k0lg as sortedWith,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { xDataClassPathInsideSet2a49hafkm1zud as xDataClassPathInsideSet } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/ConditionBuilder.mjs';
import {
  mapCapacity1h45rc3eh9p2l as mapCapacity,
  checkCountOverflow1ro2fe1r4xvgf as checkCountOverflow,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { coerceAtLeast2bkz8m9ik7hep as coerceAtLeast } from '../../../../../../kotlin-kotlin-stdlib/kotlin/ranges/_Ranges.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import {
  CareLocationProgrameuu05ugy00sb as CareLocationProgram,
  ID3lnbkn76l7dgd as ID_3,
} from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/careRates.mjs';
import { addAll1k27qatfgp3k5 as addAll } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/MutableCollections.mjs';
import { get_yearMonth3uo9i62rhbu6p as get_yearMonth } from '../../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/YearMonth.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { getValue48kllevslyh6 as getValue } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Maps.mjs';
import { Month_JULY_getInstance27j7cq5mx4kli as Month_JULY_getInstance } from '../../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/Month.mjs';
import { Collection1k04j3hzsbod0 as Collection } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import {
  CareTime_FullTime_getInstance2puuq5c8w5gwp as CareTime_FullTime_getInstance,
  CareTime_PartTime_getInstance3kqj07ymkbbng as CareTime_PartTime_getInstance,
  Type_BeforeAfter_getInstance1cykxa2neckgn as Type_BeforeAfter_getInstance,
} from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/attendance.mjs';
import { compareBy2697bq0ffft96 as compareBy } from '../../../../../../kotlin-kotlin-stdlib/kotlin/comparisons/Comparisons.mjs';
import { PluginGeneratedSerialDescriptorqdzeg5asqhfg as PluginGeneratedSerialDescriptor } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginGeneratedSerialDescriptor.mjs';
import {
  StringSerializer_getInstance1p9zda6r6kb23 as StringSerializer_getInstance,
  IntSerializer_getInstance3jyhns9ue706g as IntSerializer_getInstance,
  DoubleSerializer_getInstance1tuvibnyg07o1 as DoubleSerializer_getInstance,
} from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/Primitives.mjs';
import { UnknownFieldExceptiona60e3a6v1xqo as UnknownFieldException } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializationExceptions.mjs';
import {
  typeParametersSerializers2likxjr48tr7y as typeParametersSerializers,
  GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer,
} from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import {
  protoOf180f3jzyo7rfj as protoOf,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  equals2au1ep9vhcato as equals,
  createThis2j2avj17cvnv2 as createThis,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { getNumberHashCode2l4nbdcihl25f as getNumberHashCode } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/bitUtils.mjs';
import { throwMissingFieldException2cmke0v3ynf14 as throwMissingFieldException } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginExceptions.mjs';
import { SerializableWithd2dap36updxd as SerializableWith } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializersJs.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function SingleDaysPage$render$lambda$slambda(this$0, $this_exportButton) {
  return constructCallableReference(($this$Action, $completion) => orPromise($completion, function *($completion) {
    var tmp = Companion_instance_1;
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = get_currentSessionNotNull();
    var tmp_0 = (yield* await_0(this_0, $completion)).api_1;
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_1 = this$0.filter_1;
    var tmp$ret$1 = yield* await_1(this_1, $completion);
    var rows = yield* tmp.fetchAll_ml4x94_k$(tmp_0, tmp$ret$1, $completion);
    var csv = (new (CsvFormat())(new (StringDeferringConfig())(EmptySerializersModule(), VOID, ''))).encodeToString_k0apqx_k$(ListSerializer(Companion_instance_1.serializer_9w0wvi_k$()), rows);
    var tmp_1 = $this_exportButton.get_context_h02k06_k$();
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_2 = this$0.filter_1;
    var tmp_2 = (yield* await_1(this_2, $completion)).start_1.toString();
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_3 = this$0.filter_1;
    var tmp$ret$3 = yield* await_1(this_3, $completion);
    yield* download(tmp_1, 'service-report-' + tmp_2 + '-' + tmp$ret$3.endInclusive_1.toString() + '.csv', toBlob(csv, 'text/csv'), VOID, $completion);
    return Unit_instance;
  }), 1);
}
function SingleDaysPage$render$slambda(this$0) {
  return constructCallableReference(($this$rememberSuspending, $completion) => orPromise($completion, function *($completion) {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = get_currentSessionNotNull();
    var tmp = (yield* await_0(this_0, $completion)).api_1.get_singleChildDay_52scz3_k$();
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_1 = this$0.filter_1;
    var tmp$ret$1 = yield* await_1(this_1, $completion);
    var days = yield* tmp.query_o986pg_k$(new (Query())(tmp$ret$1.toCondition_oj74tc_k$(), VOID, VOID, 100000), $completion);
    return yield* Companion_instance.calculate_mx8h7j_k$(days, $completion);
  }), 1);
}
function SingleDaysPage$render$lambda$lambda$lambda(day) {
  return new (Cents())(day.totalContributions_1);
}
function SingleDaysPage$render$lambda$lambda($next) {
  return ($this$swap) => {
    $next.render_b3nvws_k$($this$swap, SingleDaysPage$render$lambda$lambda$lambda);
    return Unit_instance;
  };
}
function SingleDaysPage$render$lambda($this$shownWhen) {
  return get_current(Companion_instance_0).equals(Platform_Web_getInstance());
}
var SingleDaysPageClass;
function SingleDaysPage() {
  if (SingleDaysPageClass === VOID) {
    class $ {
      constructor() {
        this.filter_1 = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(new (ReportFilters())());
      }
      get_title_iz32un_k$() {
        return new (Constant())(_Constant___init__impl__v45mub('Billed Days'));
      }
      render_w3x9d1_k$(_this__u8e3s4) {
        // Inline function 'org.thecommunitygroupinc.cares.views.components.fullWidthPage' call
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_0 = get_scrolling(_this__u8e3s4);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element = new (RowOrCol())(this_0.get_context_h02k06_k$());
        ensureOutermostElement(element);
        this_0.willAddChild_hz2iwc_k$(element);
        element.set_vertical_nuap32_k$(true);
        element.set_themeBase_daz04n_k$(Companion_getInstance().fromParentNonCascading_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        var this_1 = themed(element, CompactSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_0 = new (RowOrCol())(this_1.get_context_h02k06_k$());
        ensureOutermostElement(element_0);
        this_1.willAddChild_hz2iwc_k$(element_0);
        element_0.set_vertical_nuap32_k$(false);
        // Inline function 'com.lightningkite.kiteui.views.expanding' call
        var this_2 = get_atBottomStart(element_0);
        var tmp$ret$10 = weight(this_2, 1.0);
        h1(tmp$ret$10, 'Billed Days');
        reportFilterMenu(element_0, this.filter_1);
        exportButton(element_0, ($this$exportButton) => {
          $this$exportButton.set_action_2ds022_k$(Action('Export service report', VOID, VOID, VOID, VOID, VOID, SingleDaysPage$render$lambda$slambda(this, $this$exportButton)));
          return Unit_instance;
        });
        element_0.onStartup_vrxh3i_k$();
        this_1.addChild_2qpft2_k$(element_0);
        reportFilterBar(element, this.filter_1);
        var grid = rememberSuspending(VOID, VOID, VOID, SingleDaysPage$render$slambda(this));
        // Inline function 'com.lightningkite.kiteui.views.direct.swapping' call
        // Inline function 'com.lightningkite.kiteui.views.direct.swapView' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_1 = new (SwapView())(element.get_context_h02k06_k$());
        ensureOutermostElement(element_1);
        element.willAddChild_hz2iwc_k$(element_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.swapping' call
        var this_3 = element_1;
        var queue = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
        var alreadySwapping = {_v: false};
        reactive(this_3, 8, ($this$reactive) => {
          var c = $this$reactive.invoke_r7m7el_k$(grid);
          queue.add_utx5q5_k$(c);
          var tmp;
          if (alreadySwapping._v) {
            return Unit_instance;
          }
          alreadySwapping._v = true;
          $l$loop: while (true) {
            // Inline function 'kotlin.collections.isNotEmpty' call
            if (!!queue.isEmpty_y1axqb_k$()) {
              break $l$loop;
            }
            var next = queue.removeAt_6niowx_k$(0);
            try {
              var tmp_0 = Companion_getInstance_0().Fade_1;
              this_3.swap_26x94b_k$(tmp_0, SingleDaysPage$render$lambda$lambda(next));
            } catch ($p) {
              if ($p instanceof Exception()) {
                var e = $p;
                report(Exception().new_kotlin_Exception_9qyiel_k$('Failed to render ' + toString(next), e), 'SwapView.swapping');
              } else {
                throw $p;
              }
            }
          }
          alreadySwapping._v = false;
          return Unit_instance;
        });
        element_1.onStartup_vrxh3i_k$();
        element.addChild_2qpft2_k$(element_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        var this_4 = shownWhen(element, VOID, VOID, SingleDaysPage$render$lambda);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_2 = new (Space())(this_4.get_context_h02k06_k$(), 1.0);
        ensureOutermostElement(element_2);
        this_4.willAddChild_hz2iwc_k$(element_2);
        element_2.onStartup_vrxh3i_k$();
        this_4.addChild_2qpft2_k$(element_2);
        element.onStartup_vrxh3i_k$();
        this_0.addChild_2qpft2_k$(element);
        return Unit_instance;
      }
    }
    initMetadataForClass($, 'SingleDaysPage', SingleDaysPage, VOID, [Page()]);
    SingleDaysPageClass = $;
  }
  return SingleDaysPageClass;
}
function ServiceReportRow$Companion$fetchAll$lambda(it) {
  return it.provider_1;
}
function ServiceReportRow$Companion$fetchAll$lambda_0(it) {
  return it.location_1;
}
function ServiceReportRow$Companion$fetchAll$lambda_1(it) {
  return it.child_1;
}
function ServiceReportRow$Companion$fetchAll$lambda_2(it) {
  return it.serviceMonth_1;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      *fetchAll_ml4x94_k$(api, filter, $completion) {
        var days = yield* api.get_singleChildDay_52scz3_k$().query_o986pg_k$(new (Query())(filter.toCondition_oj74tc_k$(), VOID, VOID, 2147483647), $completion);
        var tmp = api.get_childPlacement_o77pq_k$();
        var tmp2 = 2147483647;
        // Inline function 'com.lightningkite.services.database.Query' call
        // Inline function 'kotlin.collections.listOf' call
        var orderBy = emptyList();
        // Inline function 'com.lightningkite.services.database.path' call
        // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
        var tmp_0 = serializerOrContextual(createKType(getKClass(ChildPlacement()), arrayOf([]), false));
        var tmp$ret$3 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
        var it = new (DataClassPathSelf())(tmp$ret$3);
        var tmp_1 = get__id(it);
        // Inline function 'kotlin.collections.map' call
        // Inline function 'kotlin.collections.mapTo' call
        var destination = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(days, 10));
        var _iterator__ex2g4s = days.iterator_jk1svi_k$();
        while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
          var item = _iterator__ex2g4s.next_20eer_k$();
          var tmp$ret$7 = new (ID())(item.placement_1);
          destination.add_utx5q5_k$(tmp$ret$7);
        }
        var tmp$ret$4 = xDataClassPathInsideSet(tmp_1, toSet(destination));
        var tmp$ret$0 = new (Query())(tmp$ret$4, orderBy, 0, tmp2);
        // Inline function 'kotlin.collections.associateBy' call
        var this_0 = yield* tmp.query_o986pg_k$(tmp$ret$0, $completion);
        var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
        // Inline function 'kotlin.collections.associateByTo' call
        var destination_0 = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(capacity);
        var _iterator__ex2g4s_0 = this_0.iterator_jk1svi_k$();
        while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
          var element = _iterator__ex2g4s_0.next_20eer_k$();
          var tmp$ret$10 = new (ID())(element._id_1);
          destination_0.put_4fpzoq_k$(tmp$ret$10, element);
        }
        var placements = destination_0;
        var tmp_2 = api.get_family_d7lffx_k$();
        var tmp2_0 = 2147483647;
        // Inline function 'com.lightningkite.services.database.Query' call
        // Inline function 'kotlin.collections.listOf' call
        var orderBy_0 = emptyList();
        // Inline function 'com.lightningkite.services.database.path' call
        // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
        var tmp_3 = serializerOrContextual(createKType(getKClass(Family()), arrayOf([]), false));
        var tmp$ret$14 = isInterface(tmp_3, KSerializer()) ? tmp_3 : THROW_CCE();
        var it_0 = new (DataClassPathSelf())(tmp$ret$14);
        var tmp_4 = get__id_0(it_0);
        // Inline function 'kotlin.collections.map' call
        // Inline function 'kotlin.collections.mapTo' call
        var destination_1 = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(days, 10));
        var _iterator__ex2g4s_1 = days.iterator_jk1svi_k$();
        while (_iterator__ex2g4s_1.hasNext_bitz1p_k$()) {
          var item_0 = _iterator__ex2g4s_1.next_20eer_k$();
          var tmp$ret$18 = new (ID_0())(item_0.family_1);
          destination_1.add_utx5q5_k$(tmp$ret$18);
        }
        var tmp$ret$15 = xDataClassPathInsideSet(tmp_4, toSet(destination_1));
        var tmp$ret$11 = new (Query())(tmp$ret$15, orderBy_0, 0, tmp2_0);
        // Inline function 'kotlin.collections.associateBy' call
        var this_1 = yield* tmp_2.query_o986pg_k$(tmp$ret$11, $completion);
        var capacity_0 = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_1, 10)), 16);
        // Inline function 'kotlin.collections.associateByTo' call
        var destination_2 = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(capacity_0);
        var _iterator__ex2g4s_2 = this_1.iterator_jk1svi_k$();
        while (_iterator__ex2g4s_2.hasNext_bitz1p_k$()) {
          var element_0 = _iterator__ex2g4s_2.next_20eer_k$();
          var tmp$ret$21 = new (ID_0())(element_0._id_1);
          destination_2.put_4fpzoq_k$(tmp$ret$21, element_0);
        }
        var families = destination_2;
        var tmp_5 = api.get_careProvider_y0cmmt_k$();
        var tmp2_1 = 2147483647;
        // Inline function 'com.lightningkite.services.database.Query' call
        // Inline function 'kotlin.collections.listOf' call
        var orderBy_1 = emptyList();
        // Inline function 'com.lightningkite.services.database.path' call
        // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
        var tmp_6 = serializerOrContextual(createKType(getKClass(CareProvider()), arrayOf([]), false));
        var tmp$ret$25 = isInterface(tmp_6, KSerializer()) ? tmp_6 : THROW_CCE();
        var it_1 = new (DataClassPathSelf())(tmp$ret$25);
        var tmp_7 = get__id_1(it_1);
        // Inline function 'kotlin.collections.map' call
        // Inline function 'kotlin.collections.mapTo' call
        var destination_3 = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(days, 10));
        var _iterator__ex2g4s_3 = days.iterator_jk1svi_k$();
        while (_iterator__ex2g4s_3.hasNext_bitz1p_k$()) {
          var item_1 = _iterator__ex2g4s_3.next_20eer_k$();
          var tmp$ret$29 = new (ID_1())(item_1.provider_1);
          destination_3.add_utx5q5_k$(tmp$ret$29);
        }
        var tmp$ret$26 = xDataClassPathInsideSet(tmp_7, toSet(destination_3));
        var tmp$ret$22 = new (Query())(tmp$ret$26, orderBy_1, 0, tmp2_1);
        // Inline function 'kotlin.collections.associateBy' call
        var this_2 = yield* tmp_5.query_o986pg_k$(tmp$ret$22, $completion);
        var capacity_1 = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_2, 10)), 16);
        // Inline function 'kotlin.collections.associateByTo' call
        var destination_4 = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(capacity_1);
        var _iterator__ex2g4s_4 = this_2.iterator_jk1svi_k$();
        while (_iterator__ex2g4s_4.hasNext_bitz1p_k$()) {
          var element_1 = _iterator__ex2g4s_4.next_20eer_k$();
          var tmp$ret$32 = new (ID_1())(element_1._id_1);
          destination_4.put_4fpzoq_k$(tmp$ret$32, element_1);
        }
        var providers = destination_4;
        var tmp_8 = api.get_careLocation_drerzj_k$();
        var tmp2_2 = 2147483647;
        // Inline function 'com.lightningkite.services.database.Query' call
        // Inline function 'kotlin.collections.listOf' call
        var orderBy_2 = emptyList();
        // Inline function 'com.lightningkite.services.database.path' call
        // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
        var tmp_9 = serializerOrContextual(createKType(getKClass(CareLocation()), arrayOf([]), false));
        var tmp$ret$36 = isInterface(tmp_9, KSerializer()) ? tmp_9 : THROW_CCE();
        var it_2 = new (DataClassPathSelf())(tmp$ret$36);
        var tmp_10 = get__id_2(it_2);
        // Inline function 'kotlin.collections.map' call
        // Inline function 'kotlin.collections.mapTo' call
        var destination_5 = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(days, 10));
        var _iterator__ex2g4s_5 = days.iterator_jk1svi_k$();
        while (_iterator__ex2g4s_5.hasNext_bitz1p_k$()) {
          var item_2 = _iterator__ex2g4s_5.next_20eer_k$();
          var tmp$ret$40 = new (ID_2())(item_2.location_1);
          destination_5.add_utx5q5_k$(tmp$ret$40);
        }
        var tmp$ret$37 = xDataClassPathInsideSet(tmp_10, toSet(destination_5));
        var tmp$ret$33 = new (Query())(tmp$ret$37, orderBy_2, 0, tmp2_2);
        // Inline function 'kotlin.collections.associateBy' call
        var this_3 = yield* tmp_8.query_o986pg_k$(tmp$ret$33, $completion);
        var capacity_2 = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_3, 10)), 16);
        // Inline function 'kotlin.collections.associateByTo' call
        var destination_6 = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(capacity_2);
        var _iterator__ex2g4s_6 = this_3.iterator_jk1svi_k$();
        while (_iterator__ex2g4s_6.hasNext_bitz1p_k$()) {
          var element_2 = _iterator__ex2g4s_6.next_20eer_k$();
          var tmp$ret$43 = new (ID_2())(element_2._id_1);
          destination_6.put_4fpzoq_k$(tmp$ret$43, element_2);
        }
        var locations = destination_6;
        var tmp_11 = api.get_careLocationPrograms_g0oima_k$();
        var tmp2_3 = 2147483647;
        // Inline function 'com.lightningkite.services.database.Query' call
        // Inline function 'kotlin.collections.listOf' call
        var orderBy_3 = emptyList();
        // Inline function 'com.lightningkite.services.database.path' call
        // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
        var tmp_12 = serializerOrContextual(createKType(getKClass(CareLocationProgram()), arrayOf([]), false));
        var tmp$ret$47 = isInterface(tmp_12, KSerializer()) ? tmp_12 : THROW_CCE();
        var it_3 = new (DataClassPathSelf())(tmp$ret$47);
        var tmp_13 = get__id_3(it_3);
        // Inline function 'kotlin.collections.flatMap' call
        var tmp0 = placements.get_values_ksazhn_k$();
        // Inline function 'kotlin.collections.flatMapTo' call
        var destination_7 = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
        var _iterator__ex2g4s_7 = tmp0.iterator_jk1svi_k$();
        while (_iterator__ex2g4s_7.hasNext_bitz1p_k$()) {
          var element_3 = _iterator__ex2g4s_7.next_20eer_k$();
          var list = element_3.schedule_1.get_programs_mo5naw_k$();
          addAll(destination_7, list);
        }
        var tmp$ret$48 = xDataClassPathInsideSet(tmp_13, toSet(destination_7));
        var tmp$ret$44 = new (Query())(tmp$ret$48, orderBy_3, 0, tmp2_3);
        // Inline function 'kotlin.collections.associateBy' call
        var this_4 = yield* tmp_11.query_o986pg_k$(tmp$ret$44, $completion);
        var capacity_3 = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_4, 10)), 16);
        // Inline function 'kotlin.collections.associateByTo' call
        var destination_8 = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(capacity_3);
        var _iterator__ex2g4s_8 = this_4.iterator_jk1svi_k$();
        while (_iterator__ex2g4s_8.hasNext_bitz1p_k$()) {
          var element_4 = _iterator__ex2g4s_8.next_20eer_k$();
          var tmp$ret$54 = new (ID_3())(element_4._id_1);
          destination_8.put_4fpzoq_k$(tmp$ret$54, element_4);
        }
        var programs = destination_8;
        // Inline function 'kotlin.collections.groupBy' call
        // Inline function 'kotlin.collections.groupByTo' call
        var destination_9 = LinkedHashMap().new_kotlin_collections_LinkedHashMap_ga0any_k$();
        var _iterator__ex2g4s_9 = days.iterator_jk1svi_k$();
        while (_iterator__ex2g4s_9.hasNext_bitz1p_k$()) {
          var element_5 = _iterator__ex2g4s_9.next_20eer_k$();
          var key = to(new (ID())(element_5.placement_1), get_yearMonth(element_5.forDate_1));
          // Inline function 'kotlin.collections.getOrPut' call
          var value = destination_9.get_wei43m_k$(key);
          var tmp_14;
          if (value == null) {
            var answer = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
            destination_9.put_4fpzoq_k$(key, answer);
            tmp_14 = answer;
          } else {
            tmp_14 = value;
          }
          var list_0 = tmp_14;
          list_0.add_utx5q5_k$(element_5);
        }
        // Inline function 'kotlin.collections.map' call
        // Inline function 'kotlin.collections.mapTo' call
        var destination_10 = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(destination_9.get_size_woubt6_k$());
        // Inline function 'kotlin.collections.iterator' call
        var _iterator__ex2g4s_10 = destination_9.get_entries_p20ztl_k$().iterator_jk1svi_k$();
        while (_iterator__ex2g4s_10.hasNext_bitz1p_k$()) {
          var item_3 = _iterator__ex2g4s_10.next_20eer_k$();
          // Inline function 'kotlin.collections.component1' call
          var key_0 = item_3.get_key_18j28a_k$();
          // Inline function 'kotlin.collections.component2' call
          var days_0 = item_3.get_value_j01efc_k$();
          var placementId = key_0.component1_7eebsc_k$().raw_1;
          var month = key_0.component2_7eebsb_k$();
          var placement = getValue(placements, new (ID())(placementId));
          // Inline function 'kotlin.collections.map' call
          // Inline function 'kotlin.collections.mapTo' call
          var destination_11 = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(days_0, 10));
          var _iterator__ex2g4s_11 = days_0.iterator_jk1svi_k$();
          while (_iterator__ex2g4s_11.hasNext_bitz1p_k$()) {
            var item_4 = _iterator__ex2g4s_11.next_20eer_k$();
            var tmp$ret$68 = item_4.attendance_1;
            destination_11.add_utx5q5_k$(tmp$ret$68);
          }
          var attendance = destination_11;
          var tmp_15 = getValue(providers, new (ID_1())(placement.provider_1)).vendorNumber_1;
          var tmp_16 = getValue(providers, new (ID_1())(placement.provider_1)).name_1;
          var tmp_17 = getValue(locations, new (ID_2())(placement.location_1)).name_1;
          var tmp_18 = getValue(families, new (ID_0())(placement.family_1)).shortId_1;
          var tmp_19 = month.get_month_ivc8d3_k$().compareTo_30rs7w_k$(Month_JULY_getInstance()) >= 0 ? month.year_1 + 1 | 0 : month.year_1;
          // Inline function 'kotlin.collections.mapNotNull' call
          var tmp0_0 = placement.schedule_1.get_all_18j9hk_k$();
          // Inline function 'kotlin.collections.mapNotNullTo' call
          var destination_12 = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
          // Inline function 'kotlin.collections.forEach' call
          var _iterator__ex2g4s_12 = tmp0_0.iterator_jk1svi_k$();
          while (_iterator__ex2g4s_12.hasNext_bitz1p_k$()) {
            var element_6 = _iterator__ex2g4s_12.next_20eer_k$();
            var tmp_20 = element_6 == null ? null : element_6.program_1;
            var tmp0_safe_receiver = tmp_20 == null ? null : new (ID_3())(tmp_20);
            if (tmp0_safe_receiver == null)
              null;
            else {
              // Inline function 'kotlin.let' call
              destination_12.add_utx5q5_k$(tmp0_safe_receiver);
            }
          }
          var tmp_21 = toSet(destination_12);
          var tmp_22 = joinToString(tmp_21, '; ', VOID, VOID, VOID, VOID, (it) => getValue(programs, it).name_1);
          var tmp_23 = month.toString();
          var tmp$ret$76;
          $l$block: {
            // Inline function 'kotlin.collections.count' call
            var tmp_24;
            if (isInterface(attendance, Collection())) {
              tmp_24 = attendance.isEmpty_y1axqb_k$();
            } else {
              tmp_24 = false;
            }
            if (tmp_24) {
              tmp$ret$76 = 0;
              break $l$block;
            }
            var count = 0;
            var _iterator__ex2g4s_13 = attendance.iterator_jk1svi_k$();
            while (_iterator__ex2g4s_13.hasNext_bitz1p_k$()) {
              var element_7 = _iterator__ex2g4s_13.next_20eer_k$();
              if (element_7.get_billedTime_8fk3ac_k$().equals(CareTime_FullTime_getInstance())) {
                count = count + 1 | 0;
                checkCountOverflow(count);
              }
            }
            tmp$ret$76 = count;
          }
          var tmp_25 = tmp$ret$76;
          var tmp$ret$78;
          $l$block_0: {
            // Inline function 'kotlin.collections.count' call
            var tmp_26;
            if (isInterface(attendance, Collection())) {
              tmp_26 = attendance.isEmpty_y1axqb_k$();
            } else {
              tmp_26 = false;
            }
            if (tmp_26) {
              tmp$ret$78 = 0;
              break $l$block_0;
            }
            var count_0 = 0;
            var _iterator__ex2g4s_14 = attendance.iterator_jk1svi_k$();
            while (_iterator__ex2g4s_14.hasNext_bitz1p_k$()) {
              var element_8 = _iterator__ex2g4s_14.next_20eer_k$();
              if (element_8.get_billedTime_8fk3ac_k$().equals(CareTime_PartTime_getInstance())) {
                count_0 = count_0 + 1 | 0;
                checkCountOverflow(count_0);
              }
            }
            tmp$ret$78 = count_0;
          }
          var tmp_27 = tmp$ret$78;
          var tmp$ret$80;
          $l$block_1: {
            // Inline function 'kotlin.collections.count' call
            var tmp_28;
            if (isInterface(attendance, Collection())) {
              tmp_28 = attendance.isEmpty_y1axqb_k$();
            } else {
              tmp_28 = false;
            }
            if (tmp_28) {
              tmp$ret$80 = 0;
              break $l$block_1;
            }
            var count_1 = 0;
            var _iterator__ex2g4s_15 = attendance.iterator_jk1svi_k$();
            while (_iterator__ex2g4s_15.hasNext_bitz1p_k$()) {
              var element_9 = _iterator__ex2g4s_15.next_20eer_k$();
              if (element_9.get_billedTime_8fk3ac_k$().type_1.equals(Type_BeforeAfter_getInstance())) {
                count_1 = count_1 + 1 | 0;
                checkCountOverflow(count_1);
              }
            }
            tmp$ret$80 = count_1;
          }
          var tmp_29 = tmp$ret$80;
          var tmp$ret$82;
          $l$block_2: {
            // Inline function 'kotlin.collections.count' call
            var tmp_30;
            if (isInterface(attendance, Collection())) {
              tmp_30 = attendance.isEmpty_y1axqb_k$();
            } else {
              tmp_30 = false;
            }
            if (tmp_30) {
              tmp$ret$82 = 0;
              break $l$block_2;
            }
            var count_2 = 0;
            var _iterator__ex2g4s_16 = attendance.iterator_jk1svi_k$();
            while (_iterator__ex2g4s_16.hasNext_bitz1p_k$()) {
              var element_10 = _iterator__ex2g4s_16.next_20eer_k$();
              if (element_10.get_transportCount_67vxxt_k$() === 1) {
                count_2 = count_2 + 1 | 0;
                checkCountOverflow(count_2);
              }
            }
            tmp$ret$82 = count_2;
          }
          var tmp_31 = tmp$ret$82;
          var tmp$ret$84;
          $l$block_3: {
            // Inline function 'kotlin.collections.count' call
            var tmp_32;
            if (isInterface(attendance, Collection())) {
              tmp_32 = attendance.isEmpty_y1axqb_k$();
            } else {
              tmp_32 = false;
            }
            if (tmp_32) {
              tmp$ret$84 = 0;
              break $l$block_3;
            }
            var count_3 = 0;
            var _iterator__ex2g4s_17 = attendance.iterator_jk1svi_k$();
            while (_iterator__ex2g4s_17.hasNext_bitz1p_k$()) {
              var element_11 = _iterator__ex2g4s_17.next_20eer_k$();
              if (element_11.get_transportCount_67vxxt_k$() === 2) {
                count_3 = count_3 + 1 | 0;
                checkCountOverflow(count_3);
              }
            }
            tmp$ret$84 = count_3;
          }
          var tmp_33 = tmp$ret$84;
          var tmp$ret$86;
          $l$block_4: {
            // Inline function 'kotlin.collections.count' call
            var tmp_34;
            if (isInterface(attendance, Collection())) {
              tmp_34 = attendance.isEmpty_y1axqb_k$();
            } else {
              tmp_34 = false;
            }
            if (tmp_34) {
              tmp$ret$86 = 0;
              break $l$block_4;
            }
            var count_4 = 0;
            var _iterator__ex2g4s_18 = attendance.iterator_jk1svi_k$();
            while (_iterator__ex2g4s_18.hasNext_bitz1p_k$()) {
              var element_12 = _iterator__ex2g4s_18.next_20eer_k$();
              if (element_12.case_1.explained_1 === true) {
                count_4 = count_4 + 1 | 0;
                checkCountOverflow(count_4);
              }
            }
            tmp$ret$86 = count_4;
          }
          var tmp_35 = tmp$ret$86;
          var tmp$ret$88;
          $l$block_5: {
            // Inline function 'kotlin.collections.count' call
            var tmp_36;
            if (isInterface(attendance, Collection())) {
              tmp_36 = attendance.isEmpty_y1axqb_k$();
            } else {
              tmp_36 = false;
            }
            if (tmp_36) {
              tmp$ret$88 = 0;
              break $l$block_5;
            }
            var count_5 = 0;
            var _iterator__ex2g4s_19 = attendance.iterator_jk1svi_k$();
            while (_iterator__ex2g4s_19.hasNext_bitz1p_k$()) {
              var element_13 = _iterator__ex2g4s_19.next_20eer_k$();
              if (element_13.case_1.explained_1 === false) {
                count_5 = count_5 + 1 | 0;
                checkCountOverflow(count_5);
              }
            }
            tmp$ret$88 = count_5;
          }
          var tmp_37 = tmp$ret$88;
          var tmp$ret$90;
          $l$block_6: {
            // Inline function 'kotlin.collections.count' call
            var tmp_38;
            if (isInterface(attendance, Collection())) {
              tmp_38 = attendance.isEmpty_y1axqb_k$();
            } else {
              tmp_38 = false;
            }
            if (tmp_38) {
              tmp$ret$90 = 0;
              break $l$block_6;
            }
            var count_6 = 0;
            var _iterator__ex2g4s_20 = attendance.iterator_jk1svi_k$();
            while (_iterator__ex2g4s_20.hasNext_bitz1p_k$()) {
              var element_14 = _iterator__ex2g4s_20.next_20eer_k$();
              if (element_14.useIntermittent_1 && element_14.get_billedTime_8fk3ac_k$().equals(CareTime_FullTime_getInstance())) {
                count_6 = count_6 + 1 | 0;
                checkCountOverflow(count_6);
              }
            }
            tmp$ret$90 = count_6;
          }
          var tmp_39 = tmp$ret$90;
          var tmp$ret$92;
          $l$block_7: {
            // Inline function 'kotlin.collections.count' call
            var tmp_40;
            if (isInterface(attendance, Collection())) {
              tmp_40 = attendance.isEmpty_y1axqb_k$();
            } else {
              tmp_40 = false;
            }
            if (tmp_40) {
              tmp$ret$92 = 0;
              break $l$block_7;
            }
            var count_7 = 0;
            var _iterator__ex2g4s_21 = attendance.iterator_jk1svi_k$();
            while (_iterator__ex2g4s_21.hasNext_bitz1p_k$()) {
              var element_15 = _iterator__ex2g4s_21.next_20eer_k$();
              if (element_15.useIntermittent_1 && element_15.get_billedTime_8fk3ac_k$().equals(CareTime_PartTime_getInstance())) {
                count_7 = count_7 + 1 | 0;
                checkCountOverflow(count_7);
              }
            }
            tmp$ret$92 = count_7;
          }
          var tmp_41 = tmp$ret$92;
          // Inline function 'kotlin.collections.fold' call
          var accumulator = new (Cents())(_Cents___init__impl__6gjhxu(0n));
          var _iterator__ex2g4s_22 = days_0.iterator_jk1svi_k$();
          while (_iterator__ex2g4s_22.hasNext_bitz1p_k$()) {
            var element_16 = _iterator__ex2g4s_22.next_20eer_k$();
            var sum = accumulator.inCents_1;
            accumulator = new (Cents())(Cents__plus_impl_qsv4s8(sum, element_16.price_1));
          }
          var tmp$ret$94 = accumulator.inCents_1;
          var tmp_42 = Cents__toDouble_impl_mg3etm(tmp$ret$94);
          // Inline function 'kotlin.collections.fold' call
          var accumulator_0 = new (Cents())(_Cents___init__impl__6gjhxu(0n));
          var _iterator__ex2g4s_23 = days_0.iterator_jk1svi_k$();
          while (_iterator__ex2g4s_23.hasNext_bitz1p_k$()) {
            var element_17 = _iterator__ex2g4s_23.next_20eer_k$();
            var sum_0 = accumulator_0.inCents_1;
            accumulator_0 = new (Cents())(Cents__plus_impl_qsv4s8(sum_0, element_17.paidByFamily_1));
          }
          var tmp$ret$96 = accumulator_0.inCents_1;
          var tmp_43 = Cents__toDouble_impl_mg3etm(tmp$ret$96);
          // Inline function 'kotlin.collections.fold' call
          var accumulator_1 = new (Cents())(_Cents___init__impl__6gjhxu(0n));
          var _iterator__ex2g4s_24 = days_0.iterator_jk1svi_k$();
          while (_iterator__ex2g4s_24.hasNext_bitz1p_k$()) {
            var element_18 = _iterator__ex2g4s_24.next_20eer_k$();
            var sum_1 = accumulator_1.inCents_1;
            accumulator_1 = new (Cents())(Cents__plus_impl_qsv4s8(sum_1, element_18.totalContributions_1));
          }
          var tmp$ret$98 = accumulator_1.inCents_1;
          var tmp$ret$63 = new (ServiceReportRow())(tmp_15, tmp_16, tmp_17, placement.childName_1, tmp_18, tmp_19, tmp_22, tmp_23, tmp_25, tmp_27, tmp_29, tmp_31, tmp_33, tmp_35, tmp_37, tmp_39, tmp_41, tmp_42, tmp_43, Cents__toDouble_impl_mg3etm(tmp$ret$98));
          destination_10.add_utx5q5_k$(tmp$ret$63);
        }
        var tmp_44 = destination_10;
        var tmp_45 = ServiceReportRow$Companion$fetchAll$lambda;
        var tmp_46 = ServiceReportRow$Companion$fetchAll$lambda_0;
        var tmp_47 = ServiceReportRow$Companion$fetchAll$lambda_1;
        return sortedWith(tmp_44, compareBy([tmp_45, tmp_46, tmp_47, ServiceReportRow$Companion$fetchAll$lambda_2]));
      }
      serializer_9w0wvi_k$() {
        return $serializer_getInstance();
      }
    }
    initMetadataForCompanion($, VOID, VOID, [2]);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance_1;
function Companion_getInstance_1() {
  return Companion_instance_1;
}
var $serializerClass;
function $serializer() {
  if ($serializerClass === VOID) {
    class $ {
      constructor() {
        $serializer_instance = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('org.thecommunitygroupinc.cares.views.reports.ServiceReportRow', this, 20);
        tmp0_serialDesc.addElement_5pzumi_k$('vendorNumber', false);
        tmp0_serialDesc.addElement_5pzumi_k$('provider', false);
        tmp0_serialDesc.addElement_5pzumi_k$('location', false);
        tmp0_serialDesc.addElement_5pzumi_k$('child', false);
        tmp0_serialDesc.addElement_5pzumi_k$('fid', false);
        tmp0_serialDesc.addElement_5pzumi_k$('fiscalYear', false);
        tmp0_serialDesc.addElement_5pzumi_k$('program', false);
        tmp0_serialDesc.addElement_5pzumi_k$('serviceMonth', false);
        tmp0_serialDesc.addElement_5pzumi_k$('fullTimeDays', false);
        tmp0_serialDesc.addElement_5pzumi_k$('partTimeDays', false);
        tmp0_serialDesc.addElement_5pzumi_k$('beforeAfterSchoolDays', false);
        tmp0_serialDesc.addElement_5pzumi_k$('transportOneWay', false);
        tmp0_serialDesc.addElement_5pzumi_k$('transportTwoWay', false);
        tmp0_serialDesc.addElement_5pzumi_k$('explainedAbsences', false);
        tmp0_serialDesc.addElement_5pzumi_k$('unexplainedAbsences', false);
        tmp0_serialDesc.addElement_5pzumi_k$('fullTimeIntermittent', false);
        tmp0_serialDesc.addElement_5pzumi_k$('partTimeIntermittent', false);
        tmp0_serialDesc.addElement_5pzumi_k$('subtotal', false);
        tmp0_serialDesc.addElement_5pzumi_k$('parentPortion', false);
        tmp0_serialDesc.addElement_5pzumi_k$('tcgPaid', false);
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_di7fzd_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 0, StringSerializer_getInstance(), value.vendorNumber_1);
        tmp1_output.encodeStringElement_1n5wu2_k$(tmp0_desc, 1, value.provider_1);
        tmp1_output.encodeStringElement_1n5wu2_k$(tmp0_desc, 2, value.location_1);
        tmp1_output.encodeStringElement_1n5wu2_k$(tmp0_desc, 3, value.child_1);
        tmp1_output.encodeStringElement_1n5wu2_k$(tmp0_desc, 4, value.fid_1);
        tmp1_output.encodeIntElement_krhhce_k$(tmp0_desc, 5, value.fiscalYear_1);
        tmp1_output.encodeStringElement_1n5wu2_k$(tmp0_desc, 6, value.program_1);
        tmp1_output.encodeStringElement_1n5wu2_k$(tmp0_desc, 7, value.serviceMonth_1);
        tmp1_output.encodeIntElement_krhhce_k$(tmp0_desc, 8, value.fullTimeDays_1);
        tmp1_output.encodeIntElement_krhhce_k$(tmp0_desc, 9, value.partTimeDays_1);
        tmp1_output.encodeIntElement_krhhce_k$(tmp0_desc, 10, value.beforeAfterSchoolDays_1);
        tmp1_output.encodeIntElement_krhhce_k$(tmp0_desc, 11, value.transportOneWay_1);
        tmp1_output.encodeIntElement_krhhce_k$(tmp0_desc, 12, value.transportTwoWay_1);
        tmp1_output.encodeIntElement_krhhce_k$(tmp0_desc, 13, value.explainedAbsences_1);
        tmp1_output.encodeIntElement_krhhce_k$(tmp0_desc, 14, value.unexplainedAbsences_1);
        tmp1_output.encodeIntElement_krhhce_k$(tmp0_desc, 15, value.fullTimeIntermittent_1);
        tmp1_output.encodeIntElement_krhhce_k$(tmp0_desc, 16, value.partTimeIntermittent_1);
        tmp1_output.encodeDoubleElement_a6rqhe_k$(tmp0_desc, 17, value.subtotal_1);
        tmp1_output.encodeDoubleElement_a6rqhe_k$(tmp0_desc, 18, value.parentPortion_1);
        tmp1_output.encodeDoubleElement_a6rqhe_k$(tmp0_desc, 19, value.tcgPaid_1);
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_di7fzd_k$(encoder, value instanceof ServiceReportRow() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_local5 = 0;
        var tmp10_local6 = null;
        var tmp11_local7 = null;
        var tmp12_local8 = 0;
        var tmp13_local9 = 0;
        var tmp14_local10 = 0;
        var tmp15_local11 = 0;
        var tmp16_local12 = 0;
        var tmp17_local13 = 0;
        var tmp18_local14 = 0;
        var tmp19_local15 = 0;
        var tmp20_local16 = 0;
        var tmp21_local17 = 0.0;
        var tmp22_local18 = 0.0;
        var tmp23_local19 = 0.0;
        var tmp24_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        if (tmp24_input.decodeSequentially_xlblqy_k$()) {
          tmp4_local0 = tmp24_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp24_input.decodeStringElement_3oenpg_k$(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp24_input.decodeStringElement_3oenpg_k$(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp24_input.decodeStringElement_3oenpg_k$(tmp0_desc, 3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp24_input.decodeStringElement_3oenpg_k$(tmp0_desc, 4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          tmp9_local5 = tmp24_input.decodeIntElement_941u6a_k$(tmp0_desc, 5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          tmp10_local6 = tmp24_input.decodeStringElement_3oenpg_k$(tmp0_desc, 6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
          tmp11_local7 = tmp24_input.decodeStringElement_3oenpg_k$(tmp0_desc, 7);
          tmp3_bitMask0 = tmp3_bitMask0 | 128;
          tmp12_local8 = tmp24_input.decodeIntElement_941u6a_k$(tmp0_desc, 8);
          tmp3_bitMask0 = tmp3_bitMask0 | 256;
          tmp13_local9 = tmp24_input.decodeIntElement_941u6a_k$(tmp0_desc, 9);
          tmp3_bitMask0 = tmp3_bitMask0 | 512;
          tmp14_local10 = tmp24_input.decodeIntElement_941u6a_k$(tmp0_desc, 10);
          tmp3_bitMask0 = tmp3_bitMask0 | 1024;
          tmp15_local11 = tmp24_input.decodeIntElement_941u6a_k$(tmp0_desc, 11);
          tmp3_bitMask0 = tmp3_bitMask0 | 2048;
          tmp16_local12 = tmp24_input.decodeIntElement_941u6a_k$(tmp0_desc, 12);
          tmp3_bitMask0 = tmp3_bitMask0 | 4096;
          tmp17_local13 = tmp24_input.decodeIntElement_941u6a_k$(tmp0_desc, 13);
          tmp3_bitMask0 = tmp3_bitMask0 | 8192;
          tmp18_local14 = tmp24_input.decodeIntElement_941u6a_k$(tmp0_desc, 14);
          tmp3_bitMask0 = tmp3_bitMask0 | 16384;
          tmp19_local15 = tmp24_input.decodeIntElement_941u6a_k$(tmp0_desc, 15);
          tmp3_bitMask0 = tmp3_bitMask0 | 32768;
          tmp20_local16 = tmp24_input.decodeIntElement_941u6a_k$(tmp0_desc, 16);
          tmp3_bitMask0 = tmp3_bitMask0 | 65536;
          tmp21_local17 = tmp24_input.decodeDoubleElement_isei84_k$(tmp0_desc, 17);
          tmp3_bitMask0 = tmp3_bitMask0 | 131072;
          tmp22_local18 = tmp24_input.decodeDoubleElement_isei84_k$(tmp0_desc, 18);
          tmp3_bitMask0 = tmp3_bitMask0 | 262144;
          tmp23_local19 = tmp24_input.decodeDoubleElement_isei84_k$(tmp0_desc, 19);
          tmp3_bitMask0 = tmp3_bitMask0 | 524288;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp24_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp24_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp24_input.decodeStringElement_3oenpg_k$(tmp0_desc, 1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp24_input.decodeStringElement_3oenpg_k$(tmp0_desc, 2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp24_input.decodeStringElement_3oenpg_k$(tmp0_desc, 3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp24_input.decodeStringElement_3oenpg_k$(tmp0_desc, 4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                tmp9_local5 = tmp24_input.decodeIntElement_941u6a_k$(tmp0_desc, 5);
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              case 6:
                tmp10_local6 = tmp24_input.decodeStringElement_3oenpg_k$(tmp0_desc, 6);
                tmp3_bitMask0 = tmp3_bitMask0 | 64;
                break;
              case 7:
                tmp11_local7 = tmp24_input.decodeStringElement_3oenpg_k$(tmp0_desc, 7);
                tmp3_bitMask0 = tmp3_bitMask0 | 128;
                break;
              case 8:
                tmp12_local8 = tmp24_input.decodeIntElement_941u6a_k$(tmp0_desc, 8);
                tmp3_bitMask0 = tmp3_bitMask0 | 256;
                break;
              case 9:
                tmp13_local9 = tmp24_input.decodeIntElement_941u6a_k$(tmp0_desc, 9);
                tmp3_bitMask0 = tmp3_bitMask0 | 512;
                break;
              case 10:
                tmp14_local10 = tmp24_input.decodeIntElement_941u6a_k$(tmp0_desc, 10);
                tmp3_bitMask0 = tmp3_bitMask0 | 1024;
                break;
              case 11:
                tmp15_local11 = tmp24_input.decodeIntElement_941u6a_k$(tmp0_desc, 11);
                tmp3_bitMask0 = tmp3_bitMask0 | 2048;
                break;
              case 12:
                tmp16_local12 = tmp24_input.decodeIntElement_941u6a_k$(tmp0_desc, 12);
                tmp3_bitMask0 = tmp3_bitMask0 | 4096;
                break;
              case 13:
                tmp17_local13 = tmp24_input.decodeIntElement_941u6a_k$(tmp0_desc, 13);
                tmp3_bitMask0 = tmp3_bitMask0 | 8192;
                break;
              case 14:
                tmp18_local14 = tmp24_input.decodeIntElement_941u6a_k$(tmp0_desc, 14);
                tmp3_bitMask0 = tmp3_bitMask0 | 16384;
                break;
              case 15:
                tmp19_local15 = tmp24_input.decodeIntElement_941u6a_k$(tmp0_desc, 15);
                tmp3_bitMask0 = tmp3_bitMask0 | 32768;
                break;
              case 16:
                tmp20_local16 = tmp24_input.decodeIntElement_941u6a_k$(tmp0_desc, 16);
                tmp3_bitMask0 = tmp3_bitMask0 | 65536;
                break;
              case 17:
                tmp21_local17 = tmp24_input.decodeDoubleElement_isei84_k$(tmp0_desc, 17);
                tmp3_bitMask0 = tmp3_bitMask0 | 131072;
                break;
              case 18:
                tmp22_local18 = tmp24_input.decodeDoubleElement_isei84_k$(tmp0_desc, 18);
                tmp3_bitMask0 = tmp3_bitMask0 | 262144;
                break;
              case 19:
                tmp23_local19 = tmp24_input.decodeDoubleElement_isei84_k$(tmp0_desc, 19);
                tmp3_bitMask0 = tmp3_bitMask0 | 524288;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp24_input.endStructure_1xqz0n_k$(tmp0_desc);
        return ServiceReportRow().new_org_thecommunitygroupinc_cares_views_reports_ServiceReportRow_mw9eva_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, tmp15_local11, tmp16_local12, tmp17_local13, tmp18_local14, tmp19_local15, tmp20_local16, tmp21_local17, tmp22_local18, tmp23_local19, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [get_nullable(StringSerializer_getInstance()), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), IntSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), IntSerializer_getInstance(), IntSerializer_getInstance(), IntSerializer_getInstance(), IntSerializer_getInstance(), IntSerializer_getInstance(), IntSerializer_getInstance(), IntSerializer_getInstance(), IntSerializer_getInstance(), IntSerializer_getInstance(), DoubleSerializer_getInstance(), DoubleSerializer_getInstance(), DoubleSerializer_getInstance()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass = $;
  }
  return $serializerClass;
}
var $serializer_instance;
function $serializer_getInstance() {
  if ($serializer_instance === VOID)
    new ($serializer())();
  return $serializer_instance;
}
var ServiceReportRowClass;
function ServiceReportRow() {
  if (ServiceReportRowClass === VOID) {
    class $ {
      constructor(vendorNumber, provider, location, child, fid, fiscalYear, program, serviceMonth, fullTimeDays, partTimeDays, beforeAfterSchoolDays, transportOneWay, transportTwoWay, explainedAbsences, unexplainedAbsences, fullTimeIntermittent, partTimeIntermittent, subtotal, parentPortion, tcgPaid) {
        this.vendorNumber_1 = vendorNumber;
        this.provider_1 = provider;
        this.location_1 = location;
        this.child_1 = child;
        this.fid_1 = fid;
        this.fiscalYear_1 = fiscalYear;
        this.program_1 = program;
        this.serviceMonth_1 = serviceMonth;
        this.fullTimeDays_1 = fullTimeDays;
        this.partTimeDays_1 = partTimeDays;
        this.beforeAfterSchoolDays_1 = beforeAfterSchoolDays;
        this.transportOneWay_1 = transportOneWay;
        this.transportTwoWay_1 = transportTwoWay;
        this.explainedAbsences_1 = explainedAbsences;
        this.unexplainedAbsences_1 = unexplainedAbsences;
        this.fullTimeIntermittent_1 = fullTimeIntermittent;
        this.partTimeIntermittent_1 = partTimeIntermittent;
        this.subtotal_1 = subtotal;
        this.parentPortion_1 = parentPortion;
        this.tcgPaid_1 = tcgPaid;
      }
      toString() {
        return 'ServiceReportRow(vendorNumber=' + this.vendorNumber_1 + ', provider=' + this.provider_1 + ', location=' + this.location_1 + ', child=' + this.child_1 + ', fid=' + this.fid_1 + ', fiscalYear=' + this.fiscalYear_1 + ', program=' + this.program_1 + ', serviceMonth=' + this.serviceMonth_1 + ', fullTimeDays=' + this.fullTimeDays_1 + ', partTimeDays=' + this.partTimeDays_1 + ', beforeAfterSchoolDays=' + this.beforeAfterSchoolDays_1 + ', transportOneWay=' + this.transportOneWay_1 + ', transportTwoWay=' + this.transportTwoWay_1 + ', explainedAbsences=' + this.explainedAbsences_1 + ', unexplainedAbsences=' + this.unexplainedAbsences_1 + ', fullTimeIntermittent=' + this.fullTimeIntermittent_1 + ', partTimeIntermittent=' + this.partTimeIntermittent_1 + ', subtotal=' + this.subtotal_1 + ', parentPortion=' + this.parentPortion_1 + ', tcgPaid=' + this.tcgPaid_1 + ')';
      }
      hashCode() {
        var result = this.vendorNumber_1 == null ? 0 : getStringHashCode(this.vendorNumber_1);
        result = imul(result, 31) + getStringHashCode(this.provider_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.location_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.child_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.fid_1) | 0;
        result = imul(result, 31) + this.fiscalYear_1 | 0;
        result = imul(result, 31) + getStringHashCode(this.program_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.serviceMonth_1) | 0;
        result = imul(result, 31) + this.fullTimeDays_1 | 0;
        result = imul(result, 31) + this.partTimeDays_1 | 0;
        result = imul(result, 31) + this.beforeAfterSchoolDays_1 | 0;
        result = imul(result, 31) + this.transportOneWay_1 | 0;
        result = imul(result, 31) + this.transportTwoWay_1 | 0;
        result = imul(result, 31) + this.explainedAbsences_1 | 0;
        result = imul(result, 31) + this.unexplainedAbsences_1 | 0;
        result = imul(result, 31) + this.fullTimeIntermittent_1 | 0;
        result = imul(result, 31) + this.partTimeIntermittent_1 | 0;
        result = imul(result, 31) + getNumberHashCode(this.subtotal_1) | 0;
        result = imul(result, 31) + getNumberHashCode(this.parentPortion_1) | 0;
        result = imul(result, 31) + getNumberHashCode(this.tcgPaid_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ServiceReportRow()))
          return false;
        if (!(this.vendorNumber_1 == other.vendorNumber_1))
          return false;
        if (!(this.provider_1 === other.provider_1))
          return false;
        if (!(this.location_1 === other.location_1))
          return false;
        if (!(this.child_1 === other.child_1))
          return false;
        if (!(this.fid_1 === other.fid_1))
          return false;
        if (!(this.fiscalYear_1 === other.fiscalYear_1))
          return false;
        if (!(this.program_1 === other.program_1))
          return false;
        if (!(this.serviceMonth_1 === other.serviceMonth_1))
          return false;
        if (!(this.fullTimeDays_1 === other.fullTimeDays_1))
          return false;
        if (!(this.partTimeDays_1 === other.partTimeDays_1))
          return false;
        if (!(this.beforeAfterSchoolDays_1 === other.beforeAfterSchoolDays_1))
          return false;
        if (!(this.transportOneWay_1 === other.transportOneWay_1))
          return false;
        if (!(this.transportTwoWay_1 === other.transportTwoWay_1))
          return false;
        if (!(this.explainedAbsences_1 === other.explainedAbsences_1))
          return false;
        if (!(this.unexplainedAbsences_1 === other.unexplainedAbsences_1))
          return false;
        if (!(this.fullTimeIntermittent_1 === other.fullTimeIntermittent_1))
          return false;
        if (!(this.partTimeIntermittent_1 === other.partTimeIntermittent_1))
          return false;
        if (!equals(this.subtotal_1, other.subtotal_1))
          return false;
        if (!equals(this.parentPortion_1, other.parentPortion_1))
          return false;
        if (!equals(this.tcgPaid_1, other.tcgPaid_1))
          return false;
        return true;
      }
      static new_org_thecommunitygroupinc_cares_views_reports_ServiceReportRow_mw9eva_k$(seen0, vendorNumber, provider, location, child, fid, fiscalYear, program, serviceMonth, fullTimeDays, partTimeDays, beforeAfterSchoolDays, transportOneWay, transportTwoWay, explainedAbsences, unexplainedAbsences, fullTimeIntermittent, partTimeIntermittent, subtotal, parentPortion, tcgPaid, serializationConstructorMarker) {
        if (!(1048575 === (1048575 & seen0))) {
          throwMissingFieldException(seen0, 1048575, $serializer_getInstance().descriptor_1);
        }
        var $this = createThis(this);
        $this.vendorNumber_1 = vendorNumber;
        $this.provider_1 = provider;
        $this.location_1 = location;
        $this.child_1 = child;
        $this.fid_1 = fid;
        $this.fiscalYear_1 = fiscalYear;
        $this.program_1 = program;
        $this.serviceMonth_1 = serviceMonth;
        $this.fullTimeDays_1 = fullTimeDays;
        $this.partTimeDays_1 = partTimeDays;
        $this.beforeAfterSchoolDays_1 = beforeAfterSchoolDays;
        $this.transportOneWay_1 = transportOneWay;
        $this.transportTwoWay_1 = transportTwoWay;
        $this.explainedAbsences_1 = explainedAbsences;
        $this.unexplainedAbsences_1 = unexplainedAbsences;
        $this.fullTimeIntermittent_1 = fullTimeIntermittent;
        $this.partTimeIntermittent_1 = partTimeIntermittent;
        $this.subtotal_1 = subtotal;
        $this.parentPortion_1 = parentPortion;
        $this.tcgPaid_1 = tcgPaid;
        return $this;
      }
    }
    initMetadataForClass($, 'ServiceReportRow', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance});
    ServiceReportRowClass = $;
  }
  return ServiceReportRowClass;
}
//region block: init
Companion_instance_1 = new (Companion())();
//endregion
//region block: exports
export {
  SingleDaysPage as SingleDaysPage2w42wjhncrkcq,
};
//endregion

//# sourceMappingURL=SingleDaysPage.mjs.map
